import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#power-backup-C', key: 0 },
        { text: t('fix_tab2'), id: '#power-backup-D', key: 1 },
        { text: t('fix_tab3'), id: '#power-backup-J', key: 2 },
        // { text: t('fix_tab4'), id: '#power-backup-L', key: 3 },
        { text: t('fix_tab5'), id: '#power-backup-M', key: 4 },
        { text: t('fix_tab6'), id: '#power-backup-N', key: 5 },
    ];
    if (['au'].includes(locale)) {
        tabs.splice(3, 0, { text: t('fix_tab4'), id: '#power-backup-L', key: 3 });
    }

    if (['kr'].includes(locale)) {
        tabs.splice(3, 1);
    }

    const handleClickTab = (k: number) => setActiveTab(k);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const targetC = document.querySelector('#power-backup-C') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#power-backup-C',
            triggerHook: 1,
            offset: '50%',
            duration: targetC?.offsetHeight,
            onEnter: () => setActiveTab(0),
        });

        const targetD = document.querySelector('#power-backup-D') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#power-backup-D',
            triggerHook: 1,
            offset: '50%',
            duration: targetD?.offsetHeight,
            onEnter: () => setActiveTab(1),
        });

        const targetJ = document.querySelector('#power-backup-J') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#power-backup-J',
            triggerHook: 1,
            offset: '50%',
            duration: targetJ?.offsetHeight,
            onEnter: () => setActiveTab(2),
        });

        if (['au'].includes(locale)) {
            const targetL = document.querySelector('#power-backup-L') as HTMLDivElement;
            AniContainer.create({
                triggerElement: '#power-backup-L',
                triggerHook: 1,
                offset: '50%',
                duration: targetL?.offsetHeight,
                onEnter: () => setActiveTab(3),
            });
        }
        if (!['kr'].includes(locale)) {
            const targetM = document.querySelector('#power-backup-M') as HTMLDivElement;
            AniContainer.create({
                triggerElement: '#power-backup-M',
                triggerHook: 1,
                offset: '50%',
                duration: targetM?.offsetHeight,
                onEnter: () => setActiveTab(4),
            });
        }

        AniContainer.create({
            triggerElement: '#power-backup-N',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => setActiveTab(5),
        });

        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`power-backup-fix-tab ${css['power-backup-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any, k: number) => (
                        <a className={`tab ${activeTab === k ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
